import { put, takeLatest } from 'redux-saga/effects';
import moment from "moment";
import { REQUEST_CLOSE_DROPDOWN_ON_SCHEDULE, OPEN_MODAL, HANDLE_SCHEDULE_TICKET_CLICK, REMOVE_SCHEDULE_TICKET_CLICK } from "../actions/types";
import { closeDropDownOnSchedulePageSuccess, openModalSucceeded, handleScheduleTicketClickSucceeded } from '../actions/general.actions';
import { push } from 'connected-react-router';

function* closeDropDownOnSchedulePageSaga(action) {
    try {
        yield put(closeDropDownOnSchedulePageSuccess({ showDropDown: moment().format('x') }));
    } catch (e) {
    }
}

function* handleScheduleTicketClickSaga(action) {
    try {
        yield put(handleScheduleTicketClickSucceeded(action.payload));
        yield put(push(action.payload.film_url));
    } catch (e) {

    }
}

function* removeScheduleTicketClickSaga(action) {
    try {
        yield put(handleScheduleTicketClickSucceeded({}));
    } catch (e) {

    }
}

export default function* generalSaga() {
    yield takeLatest(REQUEST_CLOSE_DROPDOWN_ON_SCHEDULE, closeDropDownOnSchedulePageSaga);
    yield takeLatest(REMOVE_SCHEDULE_TICKET_CLICK, removeScheduleTicketClickSaga);
    yield takeLatest(HANDLE_SCHEDULE_TICKET_CLICK, handleScheduleTicketClickSaga);
}



// WEBPACK FOOTER //
// ./src/SHARED/sagas/general.saga.js